export default __webpack_public_path__ + "0a8bba8afde1d4258150eb2d77ca9cc6.svg";